angular.module('erp.other.newsandtrendsDetail').run(['$templateCache', function($templateCache) {
  $templateCache.put("tpl/outbox.htm",
    "<div class=\"mainoverall-style-newsand\">\n" +
    "  <div class=\"position-relative\" style=\"margin-bottom: 60px;\">\n" +
    "    <img src=\"//img2.mangoerp.com/userbucket/adminadmin/2025-03-21/1742541034981-zguufo4i0.png\" alt=\"芒果店长\"></img>\n" +
    "    <!-- <div ng-click=\"vm.openURL('//www.mangoerp.com/login#/signin')\" class=\"freetrialButton\">免费试用</div> -->\n" +
    "    <div ng-click=\"vm.openURL('//www.mangoerp.com/login#/signin')\" class=\"freetrialButton2\"></div>\n" +
    "  </div>\n" +
    "  <div class=\"container-newsand\">\n" +
    "    <div class=\"searchtest\" style=\"margin-bottom: 5px;font-size: 36px;\">\n" +
    "        #{{vm.searchtest.test}}\n" +
    "        <!-- ({{vm.searchtest.num}}篇) -->\n" +
    "    </div>\n" +
    "    <div class=\"flex-container-newsand p-b-20\">\n" +
    "      <div class=\"header-nav-newsand\">\n" +
    "        <section class=\"content-newsand heig-vh\" page-scroll-to-bottom=\"vm.handleScroll()\">\n" +
    "          <article class=\"post-newsand\" ng-click=\"vm.openDetailsURL(post.id, post)\" ng-repeat=\"post in vm.posts\">\n" +
    "            <div class=\"imgdiv\">\n" +
    "              <img ng-src=\"{{post.image}}\" alt=\"芒果店长\" />\n" +
    "            </div>\n" +
    "            <div class=\"post-content-newsand\">\n" +
    "              <h2>{{ post.title }}</h2>\n" +
    "              <!-- <p>{{ post.introduction }}</p> -->\n" +
    "              <pre>{{ post.introduction }}</pre>\n" +
    "              <div class=\"flex-justify-between-center\">\n" +
    "                <div class=\"flex\" style=\"max-width: 70%;\">\n" +
    "                  <div class=\"content-tag m-r-5 cursor-pointer\" ng-repeat=\"item in post.tagList\" ng-click=\"vm.opensearchTag(item.id)\">{{item.name}}</div>\n" +
    "                </div>\n" +
    "                <div>{{post.date | date:'yyyy-MM-dd'}}</div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </article>\n" +
    "          <div ng-show=\"vm.posts.length == 0\" style=\"font-size: 24px;text-align: center;margin-top: 20px;color: #6c6c6c;\">\n" +
    "              暂无相关数据\n" +
    "          </div>\n" +
    "          <!-- 更多文章 -->\n" +
    "        </section>\n" +
    "      </div>\n" +
    "      <main class=\"sidebar-newsand\">\n" +
    "        <aside class=\"sidebar-newsand\">\n" +
    "          <div class=\"position-relative\">\n" +
    "            <img class=\"position-absolute-img\" src=\"//img2.mangoerp.com/userbucket/adminadmin/2025-03-19/1742363955394.png\" alt=\"芒果店长\" srcset=\"\" />\n" +
    "            <div class=\"popular-recommendations-newsand position-relative\" style=\"padding-bottom: 1px;\">\n" +
    "              <h3>热门推荐</h3>\n" +
    "              <div class=\"popular-recommendations-newsand-ul\">\n" +
    "                <ul >\n" +
    "                  <li ng-click=\"vm.openDetailsURL(item.id, item)\" ng-repeat=\"item in vm.recommendations\">\n" +
    "                    <img src=\"//img2.mangoerp.com/userbucket/adminadmin/2025-02-27/1740637979696-zfxfby6pp.png\" alt=\"芒果店长\">\n" +
    "                    <a href=\"#\">{{ item.title }}</a>\n" +
    "                  </li>\n" +
    "                </ul>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"hot-tags-newsand\">\n" +
    "            <h3 class=\"m-b-24\">热门标签</h3>\n" +
    "            <ul class=\"hotTags-ul\">\n" +
    "              <li class=\"hotTags cursor-pointer\" ng-repeat=\"tag in vm.tags\" ng-click=\"vm.opensearchTag(tag.id)\">{{ tag.name }}</li>\n" +
    "            </ul>\n" +
    "\n" +
    "            <h3 class=\"m-b-24\">关注我们</h3>\n" +
    "            <img class=\"followUsimg\" src=\"//img2.mangoerp.com/userbucket/adminadmin/2025-03-21/1742541033543-gi62sftzf.png\" alt=\"芒果店长\" />\n" +
    "          </div>\n" +
    "        </aside>\n" +
    "      </main>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);
